import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
  Renderer2,
  OnDestroy,
} from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from '../../core/models/user.model';
import { UserService } from '../../core/services/user.service';
import { DatePickerComponent } from '@syncfusion/ej2-angular-calendars';
import { NgForm } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { DesignService } from '../../core/services/design.service';
import { AuthService } from '../../core/services/auth.service';
import { LoaderService } from '../../core/loader.service';
import { SessionStorageService } from 'angular-web-storage';
import { NameDisplayPreference } from '../../core/models/nameDisplayPreference.modal';
import { TroubleSignupDTO } from '../../core/models/troublesignup.modal';
import { environment } from '../../../environments/environment';
import { ReCaptchaV3Service } from 'ng-recaptcha';

declare var $: any;
declare var Veriff: any;

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss'],
})
export class SignupComponent implements OnInit {
  // user object that contains all the user data
  user: User = new User();
  // Date value
  @ViewChild('DOB') public DOB: DatePickerComponent | undefined;
  @ViewChild('countrySearchInput_signup')
  countrySearchInput_signup!: ElementRef;
  public date: Object = new Date();
  public currentDate: Date = new Date();
  public newDate: Number = this.currentDate.getFullYear() - 18;
  public maxDate: Date = new Date(
    this.currentDate.getMonth() +
      1 +
      '-' +
      (this.currentDate.getDate() + 1) +
      '-' +
      this.newDate.toString()
  );

  // activation code array
  actCodeArr: string[] = new Array(6);
  otpCodeArr: string[] = ['', '', '', ''];
  toDos: string[] = [];
  otp: string = '';
  userId: any;
  // error message from response
  errMsg: string[] = [];
  veriffErrMsg: string[] = [];
  invalidPhone = false;
  // flag denoting invalid sign up state.
  invalidSignUp: boolean = false;

  // flag denoting step counter for navigation
  step: number = 1;

  // flag denoting that if username exists or not
  userExists: boolean = false;

  // flag denoting that if phone number exists or not
  phoneExist: boolean = false;

  // flag denoting wrong activation code.
  incorrectActCode: boolean = false;

  // flag denoting match between password and confirm password input fields
  match: boolean = false;

  // flag denoting all fields empty
  empty: boolean = false;

  // flag denoting activation code sent again
  activationsent: boolean = false;

  // flag denoting loading gif active or inactive
  public loading = false;

  // flag dentoting sign up step
  public signupStep: number = 0;

  // flag dentoting terms and condition accepted or not
  public termsAndConditionFlag = false;
  public emailConsent = false;

  logflag: boolean;
  navigation: any;
  textVerified = false;
  firstClick: boolean = false;
  invalidOTP: boolean = false;
  otpSent = false;
  otpResent = false;
  passwordMeter = false;

  otpResendBlocked: boolean = false;
  otpResendCooldownMsg: string = '';
  otpCooldownEndTime: Date | null = null;
  otpCooldownInterval: any = null;
  otpSendInFlight: boolean = false;
  private otpCooldownPerfBaseline: number | null = null;
  private otpCooldownDurationMs: number = 15 * 60 * 1000;
  private readonly OTP_COOLDOWN_STORAGE_PREFIX = 'otp_cooldown_state_';
  private readonly OTP_WINDOW_MS = 15 * 60 * 1000;
  private readonly OTP_MAX_ATTEMPTS = 3;
  phoneChangeError: string = '';
  // check user id fully verified or not
  fullyVerified = false;
  existPhoneNumber = false;
  validAge: boolean = true;
  veriffVerified = false;
  veriffStatus: string = '';
  veriffSessionId: any;

  public countryCode: string = '+1';
  public phoneNumber: string = '';
  countries: any[] = [];
  filteredCountries: any[] = [];
  countrySearchTerm: string = '';
  selectedCountry: any = null;
  public popupCountryCode: string = '+1';
  public popupSelectedCountry: any = null;
  countryDropdownOpen: boolean = false;
  autoVerifyModalShown: boolean = false;
  errorMsg = null;
  accountSetUp = 0;
  verifyIdentity = 70;
  otpConfig = {
    length: 4,
    allowNumbersOnly: true,
    isPasswordInput: false,
    disableAutoFocus: false,
    enableAutoPaste: true,
  };
  otpCode: string = '';
  keepAsIs = false;
  previewName = '';
  errorMessage = '';
  recaptchaErrorMessage = '';
  disable = false;
  troubleSignupDTO: TroubleSignupDTO = new TroubleSignupDTO();

  constructor(
    private designService: DesignService,
    private userService: UserService,
    private router: Router,
    private authService: AuthService,
    private loaderService: LoaderService,
    private title: Title,
    private meta: Meta,
    public session: SessionStorageService,
    private route: ActivatedRoute,
    private recaptchaV3Service: ReCaptchaV3Service,
    private renderer: Renderer2
  ) {
    if (!this.authService.getLogflag()) {
      this.designService.setHeaderStyle('auth'); // Set Header Style to auth
      this.logflag = false;
    } else {
      this.logflag = true;
      this.designService.setHeaderStyle('profile'); // Set Header Style to profile
    }
    this.navigation = this.router.getCurrentNavigation();
    this.title.setTitle('CitizeX');
    let description =
      'CitizeX is social networking service based on United states politicians where all levels of government politicians can interact with message known as "Post a Review." Verified politicians can give review and response, but unregistered politicians can only read them.';
    this.meta.updateTag({ name: 'description', content: description });
    this.meta.removeTag('name= "keywords"');
  }

  ngOnInit() {
    this.renderer.addClass(document.body, 'show-captcha-badge');
    const returnUrl = this.route.snapshot.queryParams['returnUrl'];
    if (returnUrl) {
      this.session.set('returnUrl', returnUrl);
    } else {
      this.session.remove('returnUrl');
    }
    if (this.authService.getLogflag()) {
      this.user = this.authService.getUser();
      if (this.user && this.user.diditSessionId && !this.user.verified) {
        this.checkVerificationStatus();
      }
    }
    this.rehydrateCooldown();
    this.userService.getCountries().subscribe((res: any) => {
      if (res && res.success === 0) {
        this.countries = res.data;
        this.filteredCountries = res.data;
        let defaultCountry = this.countries.find(
          (c) => c.name && c.name.toLowerCase() === 'united states'
        );
        if (!defaultCountry) {
          defaultCountry = this.countries.find(
            (c) => c.name && c.name.toLowerCase().includes('united states')
          );
        }
        if (!defaultCountry) {
          defaultCountry = this.countries.find((c) => c.callingCode === '+1');
        }

        let userCountryCode = localStorage.getItem('countryCode');
        let userCountryIsoCode = localStorage.getItem('countryIsoCode');
        let userCountry = null;

        if (userCountryCode) {
          userCountry = this.countries.find(
            (c) =>
              c.callingCode === userCountryCode &&
              c.countryIsoCode === userCountryIsoCode
          );
          if (!userCountry) {
            userCountry = this.countries.find(
              (c) => c.callingCode === userCountryCode
            );
          }
        }

        if (userCountry) {
          this.selectedCountry = userCountry;
          this.countryCode = userCountry.callingCode;
          this.popupSelectedCountry = userCountry;
          this.popupCountryCode = userCountry.callingCode;
        } else if (defaultCountry) {
          this.selectedCountry = defaultCountry;
          this.countryCode = defaultCountry.callingCode;
          this.popupSelectedCountry = defaultCountry;
          this.popupCountryCode = defaultCountry.callingCode;
        } else if (this.countries.length > 0) {
          this.selectedCountry = this.countries[0];
          this.countryCode = this.countries[0].callingCode;
          this.popupSelectedCountry = this.countries[0];
          this.popupCountryCode = this.countries[0].callingCode;
        }
      }
    });

    if (this.authService.getLogflag()) {
      this.user = this.authService.getUser();
      console.log('USer:' + JSON.stringify(this.user));

      const params = new HttpParams().set(
        'userId',
        this.user.userId.toString()
      );
      this.userService.getUserDetail(params).subscribe((res: any) => {
        const respData = res;
        const success = respData.hasOwnProperty('success') ? respData.success : 0;
        const data = respData.hasOwnProperty('success') ? respData.data : respData;
        if (success == 0 && data) {
          console.log('USer response:' + JSON.stringify(respData));
          this.user.diditFlag = data.diditFlag;
          this.veriffVerified = data.diditFlag;
          this.veriffStatus = data.veriffStatus;
          this.user.firstName = data.firstName;
          this.user.lastName = data.lastName;
          this.user.textVerified = data.textVerified;
          this.user.diditFlag = data.diditFlag;
          this.veriffVerified = this.user.diditFlag;
          this.textVerified = this.user.textVerified;
          this.phoneNumber = data.phoneNumber;
          this.user.otpFirstRequestTime = data.otpFirstRequestTime;
          this.user.otpRequestCount = data.otpRequestCount;
          this.user.phoneChangeCount = data.phoneChangeCount;
          this.user.firstChangeTime = data.firstChangeTime;

          if (this.user.nameDisplayPreferenceDTO == null) {
            this.user.nameDisplayPreferenceDTO = new NameDisplayPreference();
            this.user.nameDisplayPreferenceDTO.firstName = 'full';
            this.user.nameDisplayPreferenceDTO.lastName = 'full';
            this.user.nameDisplayPreferenceDTO.middleName = 'full';
            this.user.nameDisplayPreferenceDTO.prefix = 'full';
            this.user.nameDisplayPreferenceDTO.suffix = 'full';
            if (data.name != null) {
              this.user.nameDisplayPreferenceDTO.customFirstName =
                data.name.firstName;
              this.user.nameDisplayPreferenceDTO.customLastName =
                data.name.lastName;
              this.user.nameDisplayPreferenceDTO.customMiddleName =
                data.name.middleName;
            }
            this.user.nameDisplayPreferenceDTO.keepAsIs = false;
          }
          if (this.user.textVerified && this.veriffVerified) {
            this.user.verified = true;
            this.verifyIdentity = 70;
          } else if (this.user.textVerified || this.veriffVerified) {
            this.user.verified = false;
            this.verifyIdentity = 70; // One of them is true
          } else {
            this.user.verified = false;
            this.verifyIdentity = 70; // Neither true
          }
          this.user.address = data.address;
          this.user.countryCode = data.countryCode;
          this.user.countryIsoCode = data.countryIsoCode;

          // if (this.countries.length > 0 && this.user.countryCode) {
          //   let userCountry = this.countries.find(
          //     (c) =>
          //       c.callingCode === this.user.countryCode &&
          //       c.countryIsoCode === this.user.countryIsoCode
          //   );
          //   if (!userCountry) {
          //     userCountry = this.countries.find(
          //       (c) => c.callingCode === this.user.countryCode
          //     );
          //   }
          //   if (userCountry) {
          //     this.selectedCountry = userCountry;
          //     this.countryCode = userCountry.callingCode;
          //     this.popupSelectedCountry = userCountry;
          //     this.popupCountryCode = userCountry.callingCode;
          //   }
          // }
          this.user.city = data.city;
          this.user.state = data.state;
          this.user.country = data.country;
          this.user.name = data.name;
          this.user.emailConsent = data.emailConsent;
          if (data.isEmailNotified !== undefined && data.isEmailNotified !== null) {
            this.user.isEmailNotified = data.isEmailNotified;
            this.user.isUnsubscribed = !data.isEmailNotified;
          } else {
            this.user.isUnsubscribed = data.isUnsubscribed;
            this.user.isEmailNotified = !data.isUnsubscribed;
          }
          this.authService.setSessionData(this.user);
          this.designService.sendClickEvent();
          if (data.showCongratsScreen && this.user.verified) {
            $('#congratsModal').modal('show');
          }
        }
      });

      this.step = 3;
    }
  }

  previous() {
    this.user.password = '';
    this.user.passwordconf = '';
    this.actCodeArr = ['', '', '', '', '', ''];
    this.activationsent = false;
    this.incorrectActCode = false;
    this.firstClick = true;
    if (this.step == 4) {
      this.step = 2;
      this.accountSetUp = 30;
    }
    if (this.step != 1) {
      this.step = this.step - 1;
      this.accountSetUp =
        this.step === 1 ? 0 : this.step === 2 ? 30 : this.step === 4 ? 50 : 0;
    }
    if (this.step == 1) {
      this.firstClick = false;
      this.accountSetUp = 0;
    }
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

  // This method is used for adding the data from first sign up page
  // sets the user object values and passes it to the service function
  signUp(invalid: any) {
    if (this.match == false) {
      return;
    }

    if (invalid || this.phoneExist) {
      return;
    }
    if (this.user.userId != undefined && !this.user.active) {
      //this.resendActivationCode();
    }
    if (this.validAge == false) {
      return;
    }
    this.loading = true;
    this.firstClick = true;
    this.user.signupStep = this.step;
    let email = this.user.email.toLowerCase();
    this.user.email = email;
    this.user.userName = email;
    delete this.user.address;
    delete this.user.city;
    delete this.user.state;
    delete this.user.country;
    // this.user.dateOfBirth = this.datePipe.transform(this.user.dateOfBirth, 'MM-dd-yyyy');
    this.user.dateOfBirth = null;
    console.log('date of birth:' + this.user.dateOfBirth);
    this.user.phoneNumber = this.phoneNumber;
    if (this.phoneNumber) {
      this.user.countryCode = this.countryCode;
      this.user.countryIsoCode = this.selectedCountry
        ? this.selectedCountry.countryIsoCode
        : '';
    }
    this.user.emailConsent = this.emailConsent;
    this.recaptchaErrorMessage = '';

    this.recaptchaV3Service.execute('signup').subscribe(
      (token: string) => {
        this.user.recaptchaToken = token;
        this.userService.signUp(this.user).subscribe(
          (res: any) => {
            const respData = res;
            console.log('data :' + JSON.stringify(respData.data));
            switch (respData.success) {
              case 0: {
                this.errMsg = [];
                this.invalidSignUp = false;
                this.session.set('password', this.user.password);
                this.user = respData.data;
                this.userId = this.user.userId.toString();
                this.step = 2;
                this.accountSetUp = 50;
                break;
              }
              case 1: {
                this.invalidSignUp = true;
                this.firstClick = false;
                this.errMsg = respData.message;
                break;
              }
              case 2: {
                this.step = respData.data.signupStep + 1;
                this.user = respData.data;
                return;
              }
            }
            this.loading = false;
            this.activationsent = false;
          },
          (error: any) => {
            console.error('Sign up API error:', error);
            this.loading = false;
            this.firstClick = false;
            this.recaptchaErrorMessage =
              'An error occurred during sign up. Please try again.';
          }
        );
      },
      (error: any) => {
        console.error('reCAPTCHA execution failed:', error);
        this.loading = false;
        this.firstClick = false;
        this.recaptchaErrorMessage =
          'reCAPTCHA validation failed. Please check your domain configuration or try again later.';
      }
    );
  }

  back() {
    this.step = this.step - 1;
    this.accountSetUp =
      this.step === 1 ? 0 : this.step === 2 ? 30 : this.step === 4 ? 50 : 0;
  }

  // This method verifies the activation code and returns invalid state when wrong.
  // it takes userId of the current session and the activation code entered by the user and passes it to the service method.
  activationCodeVerify(invalid: any) {
    if (invalid) {
      return;
    }

    this.user.activationCode = this.actCodeArr.join('');

    const params = new HttpParams()
      .set('userId', this.user.userId.toString())
      .set('activationCode', this.user.activationCode);

    this.userService.activationCodeVerify(params).subscribe((res) => {
      const respData = res;
      if (respData.success == 1) {
        this.incorrectActCode = true;
        this.user.activationCode = '';
        return;
      } else {
        this.incorrectActCode = false;
        // this.accountSetUp = 70;
        // this.step = 3;
        this.autoSignIn();
      }
    });
  }

  //  this method is called when clicking the resend button in activation page.
  //  it takes userId of the current session passes it to the service method.
  resendActivationCode(form: NgForm) {
    form.resetForm();
    const params = new HttpParams().set('userId', this.user.userId.toString());
    this.userService.resendActivationCode(params).subscribe((res) => {
      const respData = res;
      if (respData.success == 1) {
        this.invalidSignUp = true;
      } else {
        this.invalidSignUp = false;
        this.activationsent = true;
      }
    });
    return;
  }

  // This method is called on the username input focusout, it checks the username if it already exists and returns invalid if found existing username.
  // it takes the entered username and passes it to the service method.
  checkExistingUsername() {
    const params = new HttpParams().set('userName', this.user.userName);
    this.userService.checkExistingUsername(params).subscribe((res) => {
      const respData = res;
      if (respData.success == 1) {
        this.invalidSignUp = true;
        this.userExists = true;
        return;
      } else {
        this.invalidSignUp = false;
        this.userExists = false;
      }
    });
  }

  // This method is called on the username input focusout, it checks the username if it already exists and returns invalid if found existing username.
  // it takes the entered username and passes it to the service method.
  checkExistingPhoneNumber(phoneNumber: string) {
    const params = new HttpParams().set('phoneNumber', phoneNumber);
    this.userService.checkExistingPhoneNumber(params).subscribe((res) => {
      const respData = res;
      if (respData.success == 1) {
        this.phoneExist = true;
        return;
      } else {
        this.phoneExist = false;
      }
    });
  }

  //  This method checks whether the entered and re-entered password matches or not.
  //  on unmatch it fires a validations.
  confirmPassword() {
    if (this.user.password == this.user.passwordconf) {
      this.match = true;
    } else {
      this.match = false;
    }
  }

  // This method takes the username and password set by user and passes it to the service method.
  // it activates the account after which, user can login.
  activateProfile(invalid: any) {
    // checking if password and confirm password match
    this.confirmPassword();
    if (this.match == false) {
      invalid = true;
    }

    if (invalid) {
      return;
    }
    // let userName = this.user.userName.toLowerCase();
    // this.user.userName = userName;
    this.user.signupStep = this.step;
    this.userService.activateProfile(this.user).subscribe((res: any) => {
      const respData = res;
      if (respData.success == 1) {
        this.invalidSignUp = true;
        return;
      } else {
        this.invalidSignUp = false;
        this.autoSignIn();
      }
    });
  }

  keytab(myIndex: any, key: any, event: any) {
    if (event === 'keyup' && (key.keyCode === 8 || key.keyCode === 46)) {
      key.target.value = '';
      if (myIndex > 0) {
        myIndex = myIndex - 1;
        const myIndex2 = 'activationCode' + myIndex;
        const element = document.getElementById(myIndex2);
        if (element) {
          (element as HTMLInputElement).focus();
        }
      }
    }
    if (event === 'input' && myIndex < 5 && key.target.value !== '') {
      if (key.data in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]) {
        myIndex = myIndex + 1;
        const myIndex2 = 'activationCode' + myIndex;
        const element = document.getElementById(myIndex2);
        if (element) {
          (element as HTMLInputElement).focus();
        }
      } else {
        key.target.value = '';
      }
    }
  }

  keytabOTP(myIndex: any, key: any, event: any) {
    if (event === 'keyup' && (key.keyCode === 8 || key.keyCode === 46)) {
      key.target.value = '';
      if (myIndex > 0) {
        myIndex = myIndex - 1;
        const myIndex2 = 'otpCode1' + myIndex;
        const element = document.getElementById(myIndex2);
        if (element) {
          (element as HTMLInputElement).focus();
        }
      }
    }
    if (event === 'input' && myIndex < 3 && key.target.value !== '') {
      if (key.data in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]) {
        myIndex = myIndex + 1;
        const myIndex2 = 'otpCode1' + myIndex;
        const element = document.getElementById(myIndex2);
        if (element) {
          (element as HTMLInputElement).focus();
        }
      } else {
        key.target.value = '';
      }
    }
  }

  //to show terms and conditions
  onTermAndCondition() {
    $('#termAndCondition').modal('show');
  }

  //to-do on accepting terms and conditions.
  onAcceptTermAndCondition(ans: string) {
    $('#termAndCondition').modal('hide');
    if (ans == 'true') {
      this.termsAndConditionFlag = true;
    } else {
      this.termsAndConditionFlag = false;
    }
  }

  //to show the phone number modal.
  onTextVerification(f: NgForm) {
    this.rehydrateCooldown();
    if (this.user && this.user.phoneNumber) {
      this.phoneNumber = this.user.phoneNumber;
    }
    let userCountryCode =
      localStorage.getItem('countryCode') ||
      (this.user ? this.user.countryCode : null);
    let userCountryIsoCode =
      localStorage.getItem('countryIsoCode') ||
      (this.user ? this.user.countryIsoCode : null);

    if (userCountryCode) {
      let userCountry = this.countries.find(
        (c) =>
          c.callingCode === userCountryCode &&
          c.countryIsoCode === userCountryIsoCode
      );
      if (!userCountry) {
        userCountry = this.countries.find(
          (c) => c.callingCode === userCountryCode
        );
      }
      if (userCountry) {
        this.popupSelectedCountry = userCountry;
        this.popupCountryCode = userCountry.callingCode;
      }
    }
    $('#phoneNumberModal').modal('show');
    this.resetData(f);
  }

  onVeriffVerification() {
    const params = new HttpParams().set('userId', this.user.userId.toString());
    this.userService.createDiditSession(params).subscribe(
      (res: any) => {
        if (res && res.success == 0 && res.data) {
          let sessionData: any;
          try {
            sessionData = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
          } catch (e) {
            console.error('Error parsing session data', e);
            return;
          }

          if (!sessionData || !sessionData.url || sessionData.vendor_data !== this.user.userId.toString()) {
            console.error('Validation failed: sessionData invalid or vendor_data mismatch');
            return;
          }

          this.veriffSessionId = sessionData.session_id;
          this.user.diditSessionId = sessionData.session_id;
          this.authService.setSessionData(this.user);

          // Open the URL in the same tab automatically
          window.open(sessionData.url, '_self');
        } else {
          console.error(res ? res.message : 'Error creating verification session.');
        }
      },
      (error) => {
        console.error('Error creating Didit session', error);
      }
    );

    if (this.authService.getLogflag()) {
      this.veriffVerified = false;
      this.user = this.authService.getUser();
      this.user.verified = false;
      this.user.diditFlag = false;
      this.authService.setSessionData(this.user);
      this.designService.sendClickEvent();
    }
  }

  checkVerificationStatus() {
    const statusMsg = document.getElementById('didit-status-msg');
    if (statusMsg) statusMsg.innerText = 'Checking status...';

    const params = new HttpParams().set('userId', this.user.userId.toString());
    this.userService.getUserDetail(params).subscribe(
      (res: any) => {
        if (res.success == 0) {
          if (res.data.diditFlag || res.data.verified) {
            if (statusMsg) statusMsg.innerText = '';
            $('#veriffModal').modal('hide');

            this.user.diditSessionId = this.veriffSessionId || this.user.diditSessionId;
            this.user.diditFlag = res.data.diditFlag;
            this.veriffVerified = res.data.diditFlag;
            this.veriffStatus = res.data.veriffStatus;
            this.user.firstName = res.data.firstName;
            this.user.lastName = res.data.lastName;
            this.user.textVerified = res.data.textVerified;
            this.textVerified = res.data.textVerified;
            this.phoneNumber = res.data.phoneNumber;

            this.user.address = res.data.address;
            this.user.countryCode = res.data.countryCode;
            this.user.countryIsoCode = res.data.countryIsoCode;
            this.user.city = res.data.city;
            this.user.state = res.data.state;
            this.user.country = res.data.country;
            this.user.name = res.data.name;
            this.user.emailConsent = res.data.emailConsent;

            if (this.user.textVerified && this.veriffVerified) {
              this.user.verified = true;
              this.verifyIdentity = 70;
            } else if (this.user.textVerified || this.veriffVerified) {
              this.user.verified = false;
              this.verifyIdentity = 70;
            } else {
              this.user.verified = false;
              this.verifyIdentity = 70;
            }

            if (this.user.verified) {
              if (this.user.nameDisplayPreferenceDTO == null) {
                this.user.nameDisplayPreferenceDTO = new NameDisplayPreference();
              }
              this.user.nameDisplayPreferenceDTO.firstName = 'full';
              this.user.nameDisplayPreferenceDTO.lastName = 'full';
              this.user.nameDisplayPreferenceDTO.middleName = 'full';
              this.user.nameDisplayPreferenceDTO.prefix = 'full';
              this.user.nameDisplayPreferenceDTO.suffix = 'full';
              this.user.nameDisplayPreferenceDTO.customFirstName =
                this.user.name ? this.user.name.firstName : '';
              this.user.nameDisplayPreferenceDTO.customLastName =
                this.user.name ? this.user.name.lastName : '';
              this.user.nameDisplayPreferenceDTO.customMiddleName =
                this.user.name ? this.user.name.middleName : '';
              this.user.nameDisplayPreferenceDTO.keepAsIs = false;

              this.authService.setSessionData(this.user);
              this.designService.sendClickEvent();
              $('#congratsModal').modal('show');
            } else {
              this.authService.setSessionData(this.user);
              this.designService.sendClickEvent();
            }
          } else {
            if (statusMsg) statusMsg.innerText = 'Verification is not completed yet. Please finish the steps in the opened tab.';
          }
        } else {
          if (statusMsg) statusMsg.innerText = res.message || 'Error checking verification status.';
        }
      },
      (err) => {
        if (statusMsg) statusMsg.innerText = 'Error checking status. Please try again.';
      }
    );
  }

  //to send OTP
  sendOTP(invalid: any) {
    if (invalid) {
      return;
    }
    if (this.otpSendInFlight || this.otpResendBlocked) {
      return;
    }

    // Expire the 15-min window if it has already lapsed
    if (this.user.otpFirstRequestTime) {
      let firstTimeStr = this.user.otpFirstRequestTime;
      if (!firstTimeStr.endsWith('Z')) firstTimeStr += 'Z';
      const elapsed = Date.now() - new Date(firstTimeStr).getTime();
      if (elapsed >= this.OTP_WINDOW_MS) {
        this.user.otpRequestCount = 0;
        this.user.otpFirstRequestTime = '';
        this.clearPersistedCooldown();
      }
    }

    // Frontend 3-attempt block
    if (
      (this.user.otpRequestCount ?? 0) >= this.OTP_MAX_ATTEMPTS &&
      this.user.otpFirstRequestTime
    ) {
      let firstTimeStr = this.user.otpFirstRequestTime;
      if (!firstTimeStr.endsWith('Z')) firstTimeStr += 'Z';
      this.otpCooldownEndTime = new Date(
        new Date(firstTimeStr).getTime() + this.OTP_WINDOW_MS
      );
      this.otpResendBlocked = true;
      this.startCooldownTimer();
      return;
    }

    this.otpSendInFlight = true;
    this.loaderService.disable = true;

    this.recaptchaV3Service.execute('send_otp').subscribe(
      (token: string) => {
        const payload = {
          userId: this.user.userId.toString(),
          countryCode: this.popupCountryCode,
          countryIsoCode: this.popupSelectedCountry
            ? this.popupSelectedCountry.countryIsoCode
            : '',
          phoneNumber: this.phoneNumber.toString(),
          recaptchaToken: token, // added token to params
        };

        this.userService.sendOTP(payload).subscribe(
          (res) => {
            const respData = res;
            if (respData.success == 0) {
              this.otpSent = true;
              this.phoneChangeError = '';

              if (!this.user.otpFirstRequestTime) {
                this.user.otpFirstRequestTime = new Date().toISOString();
              }
              this.user.otpRequestCount = (this.user.otpRequestCount ?? 0) + 1;
              this.persistOtpCounts();

              if ((this.user.otpRequestCount ?? 0) >= this.OTP_MAX_ATTEMPTS) {
                let firstTimeStr = this.user.otpFirstRequestTime;
                if (!firstTimeStr.endsWith('Z')) firstTimeStr += 'Z';
                this.otpCooldownEndTime = new Date(
                  new Date(firstTimeStr).getTime() + this.OTP_WINDOW_MS
                );
                this.otpResendBlocked = true;
                this.startCooldownTimer();
              }

              if (this.authService.getLogflag()) {
                this.textVerified = false;
                this.user = this.authService.getUser();
                this.user.verified = false;
                this.user.textVerified = false;
                this.authService.setSessionData(this.user);
                this.designService.sendClickEvent();
              }
              this.otpSendInFlight = false;
              this.loaderService.disable = false;
              return;
            } else {
              this.invalidPhone = false;
              this.otpResent = false;
              this.loaderService.disable = false;

              const backendMsg = (respData.message || '').toString();
              const isOtpLimitMsg = /otp\s*limit|try again after/i.test(
                backendMsg
              );

              const userParams = new HttpParams().set(
                'userId',
                this.user.userId.toString()
              );
              this.userService.getUserDetail(userParams).subscribe(
                (detailRes: any) => {
                  if (detailRes && detailRes.success == 0) {
                    this.user.phoneChangeCount =
                      detailRes.data.phoneChangeCount;
                    this.user.otpRequestCount = detailRes.data.otpRequestCount;
                    this.user.otpFirstRequestTime =
                      detailRes.data.otpFirstRequestTime;
                    this.user.firstChangeTime = detailRes.data.firstChangeTime;

                    if (
                      isOtpLimitMsg ||
                      (this.user.otpRequestCount ?? 0) >= this.OTP_MAX_ATTEMPTS
                    ) {
                      this.phoneChangeError = '';
                      this.otpResendBlocked = true;
                      const cooldownMs = this.OTP_WINDOW_MS;

                      if (this.user.otpFirstRequestTime) {
                        let firstReqTime = this.user.otpFirstRequestTime;
                        if (!firstReqTime.endsWith('Z')) firstReqTime += 'Z';
                        const windowStart = new Date(firstReqTime);
                        const elapsed = Date.now() - windowStart.getTime();
                        const remaining = Math.max(cooldownMs - elapsed, 0);
                        this.otpCooldownEndTime = new Date(
                          Date.now() + (remaining > 0 ? remaining : cooldownMs)
                        );
                      } else {
                        this.otpCooldownEndTime = new Date(
                          Date.now() + cooldownMs
                        );
                      }
                      this.persistOtpCounts();
                      this.startCooldownTimer();
                    } else if (
                      this.user.phoneChangeCount &&
                      this.user.phoneChangeCount >= 2
                    ) {
                      this.phoneChangeError =
                        'You can change phone number only 2 times in 30 days.';
                      this.otpResendBlocked = false;
                    } else if (backendMsg) {
                      this.phoneChangeError = backendMsg;
                      this.otpResendBlocked = false;
                    }
                  }
                  this.otpSendInFlight = false;
                },
                () => {
                  this.otpSendInFlight = false;
                }
              );

              if (this.authService.getLogflag()) {
                this.textVerified = false;
                this.user = this.authService.getUser();
                this.user.verified = false;
                this.user.textVerified = false;
                this.authService.setSessionData(this.user);
                this.designService.sendClickEvent();
              }
            }
          },
          (error) => {
            console.error('sendOTP API failed:', error);
            this.loaderService.disable = false;
            this.otpSendInFlight = false;
          }
        );
      },
      (error) => {
        console.error('reCAPTCHA execution failed:', error);
        this.loaderService.disable = false;
        this.otpSendInFlight = false;
      }
    );
  }

  // Method to handle form submission
  onSubmit(form: NgForm): void {
    if (form.invalid || this.otpCode == '') {
      return;
    }
    this.otpVerify(form);
  }

  //to verify OTP
  otpVerify(f: NgForm) {
    this.loaderService.disable = true;

    this.otp = this.otpCodeArr.join('');
    const params = new HttpParams()
      .set('userId', this.user.userId.toString())
      .set('otp', this.otpCode)
      .set('phoneNumber', this.phoneNumber)
      .set('countryCode', this.popupCountryCode);
    this.userService.verifyOTP(params).subscribe((res) => {
      const respData = res;
      if (respData.success == 1) {
        this.invalidOTP = true;
        return;
      } else {
        this.user.otpRequestCount = 0;
        this.user.otpFirstRequestTime = '';
        this.otpResendBlocked = false;
        this.clearCooldownState();
        localStorage.setItem('countryCode', this.popupCountryCode);
        if (this.popupSelectedCountry) {
          localStorage.setItem(
            'countryIsoCode',
            this.popupSelectedCountry.countryIsoCode
          );
          this.selectedCountry = this.popupSelectedCountry;
          this.countryCode = this.popupCountryCode;
        }

        if (this.authService.getLogflag()) {
          this.user = this.authService.getUser();
          this.textVerified = true;
          this.user.textVerified = true;
          this.user.phoneNumber = this.phoneNumber;
          if (this.textVerified && this.veriffVerified) {
            this.user.verified = true;
            this.verifyIdentity = 70;
          } else if (this.textVerified || this.veriffVerified) {
            this.user.verified = false;
            this.verifyIdentity = 70; // One of them is true
          } else {
            this.user.verified = false;
            this.verifyIdentity = 70; // Neither true
          }
          this.authService.setSessionData(this.user);
          this.designService.sendClickEvent();
        }
        $('#phoneNumberModal').modal('hide');
        this.resetData(f);
        this.textVerified = true;
        this.invalidOTP = false;
        this.otpSent = false;
        this.otpCodeArr = new Array(4).fill('');
        this.phoneNumber = '';

        const params = new HttpParams().set(
          'userId',
          this.user.userId.toString()
        );
        this.userService.getUserDetail(params).subscribe((res: any) => {
          const respData = res;
          if (respData.success == 0) {
            this.user.diditFlag = respData.data.diditFlag;
            this.veriffVerified = respData.data.diditFlag;
            this.veriffStatus = respData.data.veriffStatus;
            this.user.firstName = respData.data.firstName;
            this.user.lastName = respData.data.lastName;
            this.user.textVerified = respData.data.textVerified;
            this.textVerified = respData.data.textVerified;
            this.phoneNumber = respData.data.phoneNumber;

            this.user.address = respData.data.address;
            this.user.countryCode = respData.data.countryCode;
            this.user.countryIsoCode = respData.data.countryIsoCode;
            this.user.city = respData.data.city;
            this.user.state = respData.data.state;
            this.user.country = respData.data.country;
            this.user.name = respData.data.name;
            this.user.emailConsent = respData.data.emailConsent;

            if (this.user.textVerified && this.veriffVerified) {
              this.user.verified = true;
              this.verifyIdentity = 70;
            } else if (this.user.textVerified || this.veriffVerified) {
              this.user.verified = false;
              this.verifyIdentity = 70;
            } else {
              this.user.verified = false;
              this.verifyIdentity = 70;
            }

            if (this.user.verified) {
              if (this.user.nameDisplayPreferenceDTO == null) {
                this.user.nameDisplayPreferenceDTO = new NameDisplayPreference();
              }
              this.user.nameDisplayPreferenceDTO.firstName = 'full';
              this.user.nameDisplayPreferenceDTO.lastName = 'full';
              this.user.nameDisplayPreferenceDTO.middleName = 'full';
              this.user.nameDisplayPreferenceDTO.prefix = 'full';
              this.user.nameDisplayPreferenceDTO.suffix = 'full';
              this.user.nameDisplayPreferenceDTO.customFirstName =
                this.user.name ? this.user.name.firstName : '';
              this.user.nameDisplayPreferenceDTO.customLastName =
                this.user.name ? this.user.name.lastName : '';
              this.user.nameDisplayPreferenceDTO.customMiddleName =
                this.user.name ? this.user.name.middleName : '';
              this.user.nameDisplayPreferenceDTO.keepAsIs = false;

              this.authService.setSessionData(this.user);
              this.designService.sendClickEvent();
              $('#congratsModal').modal('show');
            } else {
              this.authService.setSessionData(this.user);
              this.designService.sendClickEvent();
            }
          }
        });
      }
    });
  }

  changePhoneNumber() {
    const params = new HttpParams().set('userId', this.user.userId.toString());
    this.userService.getUserDetail(params).subscribe((res) => {
      const respData = res;
      if (respData.success == 0) {
        const user = res.data;
        user.phoneChangeCount = user.phoneChangeCount ?? 0;

        if (user.phoneChangeCount >= 2) {
          this.phoneChangeError =
            'You can only change phone number 2 times in 30 days.';
          return;
        }
        this.otpSent = false;
        this.otpCodeArr = ['', '', '', ''];
        this.otpResent = false;
        this.user.otpRequestCount = 0;
        this.user.otpFirstRequestTime = '';
        this.otpResendBlocked = false;
        this.clearCooldownState();
      }
    });
  }
  resendOTP(form: NgForm) {
    if (this.otpSendInFlight || this.otpResendBlocked) {
      return;
    }
    form.resetForm();
    this.sendOTP(false);
    this.otpResent = true;
  }

  toggleCountryDropdown(event: Event) {
    event.stopPropagation();
    this.countryDropdownOpen = !this.countryDropdownOpen;
    if (this.countryDropdownOpen) {
      this.countrySearchTerm = '';
      this.filteredCountries = this.countries;
      setTimeout(() => {
        if (this.countrySearchInput_signup) {
          this.countrySearchInput_signup.nativeElement.focus();
        }
      }, 100);
    }
  }

  searchCountry(event: any) {
    this.countrySearchTerm = event.target.value;
    this.filterCountries();
  }

  filterCountries() {
    if (!this.countrySearchTerm) {
      this.filteredCountries = this.countries;
    } else {
      this.filteredCountries = this.countries.filter(
        (c) =>
          (c.name &&
            c.name
              .toLowerCase()
              .includes(this.countrySearchTerm.toLowerCase())) ||
          (c.callingCode && c.callingCode.includes(this.countrySearchTerm))
      );
    }
  }

  selectCountry(country: any, isPopup: boolean = false) {
    if (isPopup) {
      this.popupSelectedCountry = country;
      this.popupCountryCode = country.callingCode;
    } else {
      this.selectedCountry = country;
      this.countryCode = country.callingCode;
    }
    this.countryDropdownOpen = false;
    this.countrySearchTerm = '';
    this.filteredCountries = this.countries;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.country-code-dropdown')) {
      this.countryDropdownOpen = false;
    }
  }

  //to-do on skip
  skip() {
    if (this.autoVerifyModalShown) {
      this.forceSkip();
    } else {
      $('#verifyModal').modal('show');
    }
  }

  hideSkipModal() {
    $('#verifyModal').modal('hide');
    this.autoVerifyModalShown = true;
  }

  forceSkip() {
    $('#verifyModal').modal('hide');
    if (this.authService.getLogflag()) {
      const returnUrl = this.route.snapshot.queryParams['returnUrl'];
      if (returnUrl) {
        this.router.navigateByUrl(returnUrl, { replaceUrl: true });
      } else {
        this.router.navigateByUrl('/homepage', { replaceUrl: true }); // routing to home page.
      }
    } else {
      this.step = this.step + 1;
      this.fullyVerified = false;
    }
  }

  next() {
    let user = this.authService.getUser();
    if (this.authService.getLogflag()) {
      if (user.verified) {
        const returnUrl = this.route.snapshot.queryParams['returnUrl'];
        if (user.defaultProfileId == null && user.reviewProfileId == null) {
          if (returnUrl) {
            this.session.set('returnUrl', returnUrl);
          }
          this.step = 5;
          this.accountSetUp = 80;
          this.generatePreview();
        } else {
          if (returnUrl) {
            this.router.navigateByUrl(returnUrl, { replaceUrl: true });
          } else {
            this.router.navigateByUrl('/homepage', { replaceUrl: true }); // routing to home page.
          }
        }
      } else {
        this.fullyVerified = true;
      }
    }
  }
  autoSignIn() {
    let tempUser = new User();
    tempUser.email = this.user.userName;
    tempUser.userName = this.user.userName;
    tempUser.email = this.user.userName;
    tempUser.password = this.session.get('password');
    this.userService.login(tempUser).subscribe(
      (success) => {
        this.loading = false;
        // SetLogflag for Authenticate user
        this.authService.setToken(success.token);
        this.authService.SetLogFlag();
        this.authService.setSessionData(success.data);
        if (success.data.roleProtectedObjectList[0].roleId === 1) {
          // If the logged in user is admin
          this.router.navigate(['/category']);
        } else if (success.data.roleProtectedObjectList[0].roleId === 2) {
          // If the logged in user is not admin
          if (
            success.data.verified === false ||
            success.data.verified === null
          ) {
            // user is not verified.
            // $('#signupVerificationModal').modal('show');
            $('#verifyModal').modal('show');
            this.autoVerifyModalShown = true;
            this.designService.setHeaderStyle('profile'); // Set Header Style to profile
            this.logflag = true;
            this.step = 3;
          } else if (success.data.verified === true) {
            // user is verified.
            const returnUrl = this.route.snapshot.queryParams['returnUrl'];
            if (
              success.data.defaultProfileId === null &&
              success.data.reviewProfileId == false
            ) {
              if (returnUrl) {
                this.session.set('returnUrl', returnUrl);
              }
              this.router.navigate(['/profile/search-profile']);
            } else {
              if (returnUrl) {
                this.router.navigateByUrl(returnUrl);
              } else if (success.data.defaultProfileId !== null) {
                this.router.navigate(['/homepage']);
              }
            }
          }
        }
      },
      (error) => {
        console.log('Error While Login', error);
      }
    );
  }

  checkDOB(event: any) {
    let selectedDate: Date = event.value;
    if (selectedDate != null) {
      let currentDate: Date = new Date();
      let maxYear: number = this.currentDate.getFullYear() - 18;
      let selectedYear: number = selectedDate.getFullYear();
      let selectedDates: number = selectedDate.getDate();
      let selectedMonth: number = selectedDate.getMonth() + 1;

      if (selectedYear == maxYear) {
        if (selectedMonth <= currentDate.getMonth() + 1) {
          if (selectedDates <= currentDate.getDate() + 1) {
            this.validAge = true;
          } else {
            this.validAge = false;
            this.user.dateOfBirth = null;
          }
        } else {
          this.validAge = false;
          this.user.dateOfBirth = null;
        }
      } else if (selectedYear > maxYear) {
        this.validAge = false;
        this.user.dateOfBirth = null;
      } else {
        this.validAge = true;
      }
    }
  }

  // onPestCode(event: ClipboardEvent, id: any, len: any) {
  //   // event.preventDefault();
  //   let clipboardData = event.clipboardData || (window as any).clipboardData;
  //   let pastedText = clipboardData.getData('text').trim();
  //   let myIndex = 0;
  //   document.getElementById(`${id}${len - 1}`);
  //   // if (element) {
  //   //   (element as HTMLInputElement).focus();
  //   // }
  //   for (var i = 0; i < len; i++) {
  //     const myIndex2 = id + myIndex;
  //     const input: any = document.getElementById(myIndex2);

  //     // pest value in array
  //     input.value = pastedText.charAt(i);
  //     const event = new Event('input', {
  //       bubbles: true,
  //       cancelable: true,
  //     });
  //     input.dispatchEvent(event);

  //     // pest value in input view
  //     input.value = pastedText.charAt(i);
  //     myIndex = myIndex + 1;
  //     // myIndex = myIndex + 1;
  //     // if (input && pastedText.charAt(i)) {
  //     //   input.value = pastedText.charAt(i);

  //     //   // Dispatch input event for Angular change detection
  //     //   const inputEvent = new Event('input', {
  //     //     bubbles: true,
  //     //     cancelable: true,
  //     //   });
  //     //   input.dispatchEvent(inputEvent);

  //     //   myIndex++; // Move to the next index
  //     // }
  //   }
  // }
  onPestCode(event: ClipboardEvent, id: any, len: any) {
    let clipboardData = event.clipboardData || (window as any).clipboardData;
    let pastedText = clipboardData.getData('text').trim();
    let myIndex = 0;
    // document.getElementById(`${id}${len - 1}`).focus();
    document.getElementById(`${id}${len - 1}`)?.focus();
    for (var i = 0; i < len; i++) {
      const myIndex2 = id + myIndex;
      const input: any = document.getElementById(myIndex2);

      // pest value in array
      input.value = pastedText.charAt(i);
      const event = new Event('input', {
        bubbles: true,
        cancelable: true,
      });
      input.dispatchEvent(event);

      // pest value in input view
      input.value = pastedText.charAt(i);

      myIndex = myIndex + 1;
    }
  }
  redirectToSearchProfilePage() {
    //this.router.navigate(['/profile/search-profile']);
    $('#congratsModal').modal('hide');
    const returnUrl = this.route.snapshot.queryParams['returnUrl'];
    if (returnUrl) {
      this.session.set('returnUrl', returnUrl);
    }
    this.generatePreview();
    //this.router.navigateByUrl('/profile/search-profile', { replaceUrl: true });
    this.step = 5;
    this.accountSetUp = 80;
  }

  getUserDetails() {
    const params = new HttpParams().set('userId', this.user.userId.toString());
    this.userService.getUserDetail(params).subscribe((res) => {
      const respData = res;
      if (respData.success == 0) {
        this.user = respData.data;
        this.authService.setSessionData(this.user);
      }
    });
  }

  openVerificationModal() {
    if (!this.user.verified && !this.user.diditFlag) {
      this.onVeriffVerification();
    }
  }

  openTextVerificationModal(data: NgForm) {
    if (!this.user.verified && !this.user.textVerified) {
      this.otpSent = false; // ✅ reset OTP screen
      this.otpCodeArr = ['', '', '', '']; // ✅ clear OTP inputs
      this.otpCode = ''; // ✅ clear OTP value
      this.invalidOTP = false; // ✅ clear any OTP error
      this.invalidPhone = false;
      // ✅ Delay modal open by 1 tick so Angular clears flags before rendering
      setTimeout(() => {
        this.onTextVerification(data);
      }, 0);
    }
  }

  onFocus(event: FocusEvent): void {
    const target = event.target as HTMLInputElement;
    target.select();
  }
  resetData(data: NgForm) {
    // this.phoneNumber='';
    // this.otpCodeArr= ['', '', '', ''];
    this.otpResent = false;
    data.resetForm({
      countryCode: this.countryCode,
      phoneNumber: this.phoneNumber,
    });
  }

  onOtpChange(value: string): void {
    this.otpCode = value;
    this.invalidOTP = false;
  }

  generatePreview(): void {
    const pref = this.user.nameDisplayPreferenceDTO;
    const fullName = this.user.name;
    const middleExists = !!fullName.middleName?.trim();
    const prefixExists = !!fullName.prefix?.trim();
    const suffixExists = !!fullName.suffix?.trim();

    this.errorMessage = '';
    this.disable = false;

    if (pref.keepAsIs) {
      const nameParts = [
        fullName.prefix,
        fullName.firstName,
        fullName.middleName,
        fullName.lastName,
        fullName.suffix,
      ].filter(Boolean);
      this.previewName = nameParts.join(' ').trim();
      //  this.nameSettingDTO.publicName = this.previewName;
      return;
    }

    // Validation: hide limits
    if (middleExists) {
      const hiddenCount = [
        pref.firstName,
        pref.middleName,
        pref.lastName,
      ].filter((v) => v === 'hide').length;
      if (hiddenCount > 1) {
        this.errorMessage = 'You can hide only one of the three names.';
        this.disable = true;
        this.previewName = '';
        return;
      }
    }

    if (pref.firstName === 'hide' && pref.lastName === 'hide') {
      this.errorMessage = 'You cannot hide both First Name and Last Name.';
      this.disable = true;
      this.previewName = '';
      return;
    }

    const fullShown =
      pref.firstName === 'full' ||
      (middleExists && pref.middleName === 'full') ||
      pref.lastName === 'full';

    if (
      !fullShown &&
      pref.firstName !== 'custom' &&
      pref.middleName !== 'custom' &&
      pref.lastName !== 'custom'
    ) {
      this.errorMessage = 'At least one name must be shown fully.';
      this.disable = true;
      this.previewName = '';
      return;
    }

    if (
      pref.firstName === 'initial' &&
      (!pref.middleName || pref.middleName === 'initial') &&
      pref.lastName === 'initial'
    ) {
      this.errorMessage =
        'At least one of First, Middle, or Last Name must be shown fully.';
      this.disable = true;
      this.previewName = '';
      return;
    }

    if (
      !middleExists &&
      (pref.firstName === 'hide' || pref.lastName === 'hide')
    ) {
      this.errorMessage =
        'You cannot hide names unless middle name is available.';
      this.disable = true;
      this.previewName = '';
      return;
    }

    if (
      pref.firstName !== 'full' &&
      pref.lastName !== 'full' &&
      (!middleExists || pref.middleName !== 'full')
    ) {
      this.errorMessage =
        'At least one of First, Middle, or Last Name must be shown fully.';
      this.disable = true;
      this.previewName = '';
      return;
    }

    // 🚨 Custom name validation
    const customFields: {
      field: keyof typeof pref;
      original: string;
      input: string;
    }[] = [
      {
        field: 'firstName',
        original: fullName.firstName,
        input: this.user.nameDisplayPreferenceDTO.customFirstName,
      },
      {
        field: 'middleName',
        original: fullName.middleName || '',
        input: this.user.nameDisplayPreferenceDTO.customMiddleName,
      },
      {
        field: 'lastName',
        original: fullName.lastName,
        input: this.user.nameDisplayPreferenceDTO.customLastName,
      },
    ];

    const normalize = (s: string) =>
      (s || '')
        .normalize?.('NFKD') // decompose accents
        .replace(/[\u0300-\u036f]/g, '') // remove combining diacritics
        .replace(/[^\w\s]/g, '') // drop punctuation (keeps letters/numbers/underscore)
        .replace(/\s+/g, ' ') // collapse multiple spaces
        .toLowerCase()
        .trim();

    // 🚨 Robust Custom name validation (permits substrings, order-agnostic)
    for (const { field, original, input } of customFields) {
      if (pref[field] === 'custom') {
        const rawInput = (input ?? '').trim();

        // 🚨 Blank input check
        if (!rawInput) {
          this.errorMessage = `Custom ${field.replace(
            'Name',
            ' Name'
          )} cannot be blank.`;
          this.disable = true;
          this.previewName = '';
          return;
        }

        const normOriginal = normalize(original);
        const normInput = normalize(rawInput);

        const inputWords = normInput.split(' ').filter(Boolean);

        // ✅ each input word must appear as substring in the original
        const allWordsPresent = inputWords.every((w) =>
          normOriginal.includes(w)
        );

        if (!allWordsPresent) {
          this.errorMessage =
            'Custom name must be a part of your profile name.';
          this.disable = true;
          this.previewName = '';
          return;
        }
      }
    }

    // ✅ Build the preview
    const first =
      pref.firstName === 'full'
        ? fullName.firstName
        : pref.firstName === 'initial'
        ? fullName.firstName?.charAt(0) + '.'
        : pref.firstName === 'custom'
        ? this.user.nameDisplayPreferenceDTO.customFirstName?.trim()
        : '';

    const middle = middleExists
      ? pref.middleName === 'full'
        ? fullName.middleName
        : pref.middleName === 'initial'
        ? fullName.middleName
            .split(' ')
            .filter((part) => part.trim().length > 0)
            .map((part) => part.charAt(0) + '.')
            .join(' ')
        : pref.middleName === 'custom'
        ? this.user.nameDisplayPreferenceDTO.customMiddleName?.trim()
        : ''
      : '';

    const last =
      pref.lastName === 'full'
        ? fullName.lastName
        : pref.lastName === 'initial'
        ? fullName.lastName
            .split(' ')
            .filter((part) => part.trim().length > 0)
            .map((part) => part.charAt(0) + '.')
            .join(' ')
        : pref.lastName === 'custom'
        ? this.user.nameDisplayPreferenceDTO.customLastName?.trim()
        : '';

    const prefix =
      prefixExists && pref.prefix === 'full' ? fullName.prefix : '';

    const suffix =
      suffixExists && pref.suffix === 'full' ? fullName.suffix : '';

    const parts = [prefix, first, middle, last, suffix].filter(Boolean);
    this.previewName = parts.join(' ').trim();
    // this.nameSettingDTO.publicName = this.previewName;
  }

  onFirstNameInput(event: Event): void {
    const input = (event.target as HTMLInputElement).value;
    this.user.nameDisplayPreferenceDTO.customFirstName = input;
    this.generatePreview();
  }

  onLastNameInput(event: Event): void {
    const input = (event.target as HTMLInputElement).value;
    this.user.nameDisplayPreferenceDTO.customLastName = input;
    this.generatePreview();
  }

  onMiddleNameInput(event: Event): void {
    const input = (event.target as HTMLInputElement).value;
    this.user.nameDisplayPreferenceDTO.customMiddleName = input;
    this.generatePreview();
  }

  // Purpose : For updating user
  updateUser() {
    this.generatePreview();
    // Clear custom fields if preference is not 'custom'
    if (this.user.nameDisplayPreferenceDTO.firstName !== 'custom') {
      this.user.nameDisplayPreferenceDTO.customFirstName = '';
    }

    if (this.user.nameDisplayPreferenceDTO.middleName !== 'custom') {
      this.user.nameDisplayPreferenceDTO.customMiddleName = '';
    }

    if (this.user.nameDisplayPreferenceDTO.lastName !== 'custom') {
      this.user.nameDisplayPreferenceDTO.customLastName = '';
    }
    this.userService.editUser(this.user).subscribe((res) => {
      this.authService.setSessionData(this.user);
      this.session.set('publicName', this.previewName);
      if (res.success == 0) {
        this.router.navigateByUrl('/profile/search-profile', {
          replaceUrl: true,
        });
        console.log('User updated successfully:' + JSON.stringify(this.user));
      } else {
        console.log('Error while updating user');
      }
    });
  }

  onKeepAsIsChange(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.user.nameDisplayPreferenceDTO.keepAsIs = isChecked;

    if (isChecked) {
      this.user.nameDisplayPreferenceDTO.firstName = 'full';
      this.user.nameDisplayPreferenceDTO.middleName = 'full';
      this.user.nameDisplayPreferenceDTO.lastName = 'full';
      this.user.nameDisplayPreferenceDTO.prefix =
        this.user.name.prefix != null ? 'full' : 'hide';
      this.user.nameDisplayPreferenceDTO.suffix =
        this.user.name.suffix != null ? 'full' : 'hide';
    }

    this.generatePreview();
  }

  getNamePart(
    type: 'prefix' | 'firstName' | 'middleName' | 'lastName' | 'suffix'
  ): string {
    const pref = this.user.nameDisplayPreferenceDTO[type];
    const fullName = this.user.name[type as keyof typeof this.user.name];

    if (pref === 'full') {
      return fullName || '';
    } else if (pref === 'initial') {
      return fullName
        ? fullName
            .split(' ')
            .filter((part) => part.trim().length > 0)
            .map((part) => part.charAt(0) + '.')
            .join(' ')
        : '';
    } else if (pref === 'hide') {
      return '';
    } else if (pref === 'custom') {
      // Only valid for firstName, middleName, lastName
      if (type === 'firstName') {
        return this.user.nameDisplayPreferenceDTO.customFirstName || '';
      } else if (type === 'middleName') {
        return this.user.nameDisplayPreferenceDTO.customMiddleName || '';
      } else if (type === 'lastName') {
        return this.user.nameDisplayPreferenceDTO.customLastName || '';
      }
    }

    return '';
  }

  // Purpose : To submit issue for signup
  troubleSignup(form: NgForm) {
    if (form.invalid) {
      return;
    }
    this.userService.troubleSignup(this.troubleSignupDTO).subscribe((res) => {
      if (res.success == 0) {
        this.resetForm(form);
        console.log('Issue submitted successfully');
      } else {
        console.log('Error while submitting issue');
      }
      $('#troubleSigningModal').modal('hide');
    });
  }

  resetForm(f: NgForm): void {
    f.resetForm();
    this.troubleSignupDTO = new TroubleSignupDTO();
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'show-captcha-badge');
  }
  startCooldownTimer() {
    if (this.otpCooldownInterval) {
      clearInterval(this.otpCooldownInterval);
    }

    if (this.otpCooldownEndTime) {
      const remainingNow = Math.max(
        this.otpCooldownEndTime.getTime() - Date.now(),
        0
      );
      this.otpCooldownPerfBaseline = performance.now();
      this.otpCooldownDurationMs = remainingNow;
      this.persistCooldown(this.otpCooldownEndTime);
    }

    const tick = () => {
      if (!this.otpCooldownEndTime) {
        clearInterval(this.otpCooldownInterval);
        return;
      }

      let remaining: number;
      if (this.otpCooldownPerfBaseline != null) {
        remaining =
          this.otpCooldownDurationMs -
          (performance.now() - this.otpCooldownPerfBaseline);
      } else {
        remaining = this.otpCooldownEndTime.getTime() - Date.now();
      }

      if (remaining <= 0) {
        clearInterval(this.otpCooldownInterval);
        this.otpResendBlocked = false;
        this.otpResendCooldownMsg = '';
        this.otpCooldownEndTime = null;
        this.otpCooldownPerfBaseline = null;
        this.user.otpRequestCount = 0;
        this.user.otpFirstRequestTime = '';
        this.clearPersistedCooldown();
      } else {
        const totalSeconds = Math.ceil(remaining / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        const mm = String(minutes).padStart(2, '0');
        const ss = String(seconds).padStart(2, '0');
        this.otpResendCooldownMsg = `OTP limit reached. Try again after ${mm}:${ss} minutes`;
      }
    };
    tick();
    this.otpCooldownInterval = setInterval(tick, 1000);
  }
  clearCooldownState() {
    this.user.otpRequestCount = 0;
    this.user.otpFirstRequestTime = '';
    this.otpResendBlocked = false;
    this.otpResendCooldownMsg = '';
    this.otpCooldownEndTime = null;
    this.otpCooldownPerfBaseline = null;
    if (this.otpCooldownInterval) {
      clearInterval(this.otpCooldownInterval);
    }
    this.clearPersistedCooldown();
  }

  private getCooldownStorageKey(): string {
    const uid = this.user?.userId ? this.user.userId.toString() : 'anon';
    return this.OTP_COOLDOWN_STORAGE_PREFIX + uid;
  }

  private persistCooldown(endTime: Date) {
    try {
      const state = {
        endTime: endTime.toISOString(),
        firstRequestTime: this.user?.otpFirstRequestTime || '',
        requestCount: this.user?.otpRequestCount ?? 0,
      };
      localStorage.setItem(this.getCooldownStorageKey(), JSON.stringify(state));
    } catch (e) {}
  }

  private persistOtpCounts() {
    try {
      const key = this.getCooldownStorageKey();
      const existing = localStorage.getItem(key);
      const state: any = existing ? JSON.parse(existing) : {};
      state.firstRequestTime = this.user?.otpFirstRequestTime || '';
      state.requestCount = this.user?.otpRequestCount ?? 0;
      localStorage.setItem(key, JSON.stringify(state));
    } catch (e) {}
  }

  private clearPersistedCooldown() {
    try {
      localStorage.removeItem(this.getCooldownStorageKey());
    } catch (e) {}
  }

  rehydrateCooldown(): boolean {
    try {
      const raw = localStorage.getItem(this.getCooldownStorageKey());
      if (!raw) return false;
      const state = JSON.parse(raw);
      if (!state) return false;

      // Restore counters regardless of whether cooldown endTime exists
      if (state.firstRequestTime) {
        this.user.otpFirstRequestTime = state.firstRequestTime;
      }
      if (typeof state.requestCount === 'number') {
        this.user.otpRequestCount = state.requestCount;
      }

      // Expire the 15-min window if it lapsed
      if (this.user.otpFirstRequestTime) {
        let firstTimeStr = this.user.otpFirstRequestTime;
        if (!firstTimeStr.endsWith('Z')) firstTimeStr += 'Z';
        const elapsed = Date.now() - new Date(firstTimeStr).getTime();
        if (elapsed >= this.OTP_WINDOW_MS) {
          this.user.otpRequestCount = 0;
          this.user.otpFirstRequestTime = '';
          this.clearPersistedCooldown();
          return false;
        }
      }

      if (!state.endTime) return false;
      const endTime = new Date(state.endTime);
      const remaining = endTime.getTime() - Date.now();
      if (isNaN(endTime.getTime()) || remaining <= 0) {
        return false;
      }
      this.otpCooldownEndTime = endTime;
      this.otpResendBlocked = true;
      this.startCooldownTimer();
      return true;
    } catch (e) {
      return false;
    }
  }
}
